import {fetchHandler} from 'app/util/fetchHandler';
import {getRestHeadersGet} from 'app/rest/helpers/getRestHeadersHelper';

export const synchronizeUserDrives = () => {
    const action = () => {
        return fetchHandler('/rest/userDrives/synchronize', getRestHeadersGet())
    }
    return action;
}
